import './CateogaryBlock.css'
import GridFeature from './GridFeature'
import data from '../FakeData/index.json'
import UseFetch from '../UseFetch'
import mainData from '../FetchDataLinks/index'
import GridSkeleteon from './GridSkeleteon'

function CateogaryBlock() {

    let a = 0;

    const { blogs, loading } = UseFetch(mainData.famous)

    return (
        <section className="w3l-homeblock1 py-sm-5 py-4">
            <div className="container py-md-4">
                <h3 className="section-title-left mb-4"> Best Cateogary Over {data[0].name} </h3>
                <div className="grids-area-hny main-cont-wthree-fea row">
                    {/* {blogs.map((blog) => {
                        return <GridFeature cateogary={blog.Cateogary} />
                    })} */}
                    {loading && Array(4).fill().map(() => {
                        a++;
                        return <GridSkeleteon key={`gridSkeleton${a}`} />
                    })}
                    {!loading && blogs.map((blog) => {
                        return <GridFeature key={blog.id} cateogary={blog.Cateogary} />
                    })}
                </div>
            </div>
        </section>

    )
}

export default CateogaryBlock
